/*
 * @Date: 2025-02-28 18:10:17
 * @Author: miroku.yang
 * @Description:
 */
/**
 * 功能常量枚举配置
 * */

/**
 * 登录tab类型
 */
export const LOGIN_TAB_TYPE = {
  CODE: '1', // 验证码登录
  ACCOUNT: '2', // 账号密码登录
}

/**
 * 推广渠道
 */
export const GIVEAWAY_CHANNEL = {
  GOOGLE: 'GOOGLE', // google
  INQUIRYOPPORTUNITY: 'INQUIRYOPPORTUNITY', // 商机收集
}

/**
 * cookie中key
 */
export const COOKIES_MAP = {
  TOKEN: '__cb_session_id__', // token
  USER_FAVORITE: '__cb_user_favorite__', // 用户引导页是否提交
  GIVEAWAY_CHANNEL: 'giveaway_channel', // 推广渠道
  IS_SSO: '__cb_is_sso_login__', //  使用 sso 登录，包括cm 端跳转过来
  EIDT_PAGE_FROM: '__cb_edit_page_from__', // 编辑器from url
  ACCEPT_LANGUAGE: '__cb_accept_language__', // 浏览器语言
  LANGUAGE: '__cb_language__', // 语言
}


/**
 * saas首页
 */
export const HOME_PATH = '/home'

/**
 * 全局重定向路由
 */
// export const GLOBAL_REDIRECT_PATH = '/inspiration/case'
export const GLOBAL_REDIRECT_PATH = '/inspiration/template'

/**
 * 重定向后需要cookie换取token的映射
 */
export const CHANNEL_MAP = {
  SSO: 'sso',
  SINOCLICK: 'sinoclick',
}
/**
 * 重定向后需要cookie换取token的列表
 */
export const CHANNEL_LIST = Object.values(CHANNEL_MAP)

/**
 * 微应用路由映射
 */
export const MICRO_APP_MAP: any = {
  VE: '/video/create', // VE
  CANVA_CREACTE: '/graphic/create', // 可画
  CANVA_EDIT: '/graphic/edit', // 可画
  FBE_CANVA_CREATE: '/template/create', // fbe可画
}

/**
 * 微应用路由列表
 */
export const MICRO_APP_LIST = Object.values(MICRO_APP_MAP)

/**
 * 字段类型
 */
export const DICT_KEY = {
  USER_WORKS_COLLECT_ORIGIN_TYPE: 'USER_WORKS_COLLECT_ORIGIN_TYPE', // 作品来源
  MEDIA_SLOT_SIZE: 'MEDIA_SLOT_SIZE', // 尺寸
  TEMPLATE_CHANNEL_TYPE: 'TEMPLATE_CHANNEL_TYPE', // 视频类型
  CREATIVE_WORKS_TYPE: 'CREATIVE_WORKS_TYPE', // 创意类型
  CREATIVE_WORKS_FORMAT_TYPE: 'CREATIVE_WORKS_FORMAT_TYPE', // 作品版式
  TEMPLATE_SIZE_SCALE: 'TEMPLATE_SIZE_SCALE', // 模板尺寸
  CREATIVE_WORKS_OF_TYPE: 'CREATIVE_WORKS_OF_TYPE', // 作品类型
  DISTRIBUTE_MEDIA_NAME: 'DISTRIBUTE_MEDIA_NAME', // 媒体类型
}

/**
 * mf apollo key
 */
export const MF_APOLLO_KEY = {
  SDK: 'MF_CANVA_SDK',
  LIB: 'MF_LIB_REMOTE_ENTRY',
  CANVA: 'MF_CANVA_REMOTE_ENTRY',
  TEMPLATE: 'MF_TEMPLATE_REMOTE_ENTRY',
  COMMON: 'MF_COMMON_ENTRY',
}

/**
 * mf url
 */
export const MF_REMOTE_ENTRY = {
  [MF_APOLLO_KEY.SDK]: '//sdk.canva.cn/designbutton/v2/api.js',
  [MF_APOLLO_KEY.TEMPLATE]: '//g.meetsocial.com/mf/cb/20250429/uz0m9vz4/remoteEntry.js',
  // [MF_APOLLO_KEY.TEMPLATE]: '//local.meetsocial.cn:3009/remoteEntry.js', // 3008白版ant 样式mf 3009黑版ant 样式mf
}
